<template>
<div class="container">
<img id="user" src="../assets/ICON_1.png">
<p>EasyView Clinic</p>

  <div class="icon-bor" :class="{'in':isB}">
    <div :class="{'in1':isB}">
    <img src="../assets/User.png" >
    </div>
    <input id="name" type="text" :placeholder=user v-model="username" @focus="check2" @blur="check2" @keyup.down='down' @keyup.13="down" maxlength="80">
  </div>
  <div class="icon-bor" :class="{'in':isC}">
    <div :class="{'in1':isC}">
      <img id="img1" src="../assets/Password.png" >
    </div>
    <input id="psd" type="password" :placeholder=pas  v-model="password" @keyup.up='up'  @focus="check3" @blur="check3" maxlength="30">
</div>

<div class="operate" :class="{'po1':isEs||isPo}" v-show="false">
  <div  class="operate-left"  :class="[ isA ?'Select':'noSelect']">
     <input type="checkbox" @click="choose"> <label>{{$t('remember')}}</label>
  </div>
  <div class="operate-right">
    <label  @click="forgot">{{$t('forget')}}</label>
  </div>
</div>

  <button class="login" @click="submit" :class="{'po2':isEs||isPo}">{{$t('sign in')}}</button>
  <!--<button class="sign" @click="sign">{{$t('sign up now')}}</button>-->
</div> <!--container结束-->
</template>

<script>
  import auth from '../auth/auth'
  export default {
    data() {
      return {
        username: '', password: '', user:this.$t('user'), pas:this.$t('password'),
        error: '', isA:false, isB:false, isC:false,isEs:false,isPo:false,
      }
    },
    computed:{
      getLanguage(){
        return this.$store.state.language;
      }
    },
    watch:{
      getLanguage(val){
         //this.$i18n.locale = val;
         this.user = this.$t('user');
         this.pas = this.$t('password');
      }
    },
    created() {
    let that = this;
    document.onkeydown =function(e){
      e = window.event || e;
      if(that.$route.path==='/clinic'&&(e.code==='Enter'||e.code==='enter'||e.code==='NumpadEnter')&&!e.isComposing){//验证在登录界面和按得键是回车键enter
        that.submit();//登录函数
        }
      }
    },
    mounted(){
      let f = localStorage.getItem('hcpRemember');
      if(f==='1'){
        this.username = localStorage.getItem('hcpUsername');
        this.password = localStorage.getItem('hcpPassword');
        this.isA = true;
      }else{
          this.isA = false;
      }
      let tz = -(new Date().getTimezoneOffset()/60);
      sessionStorage.setItem('tz',tz);
      if(!sessionStorage.getItem('flag')){
        auth.checkBrowser(this);
        sessionStorage.setItem('loginPath','/login');
        let OS = auth.detectOS();
        sessionStorage.setItem('OS',OS);
      }
      this.isEs = (sessionStorage.getItem('language')==='es')?true:false;
      this.isPo = (sessionStorage.getItem('language')==='po')?true:false;
    },
    methods: {
      submit() {
        var info = {
          user_name: this.username,
          user_type: 'P',
          password: this.password,
          flag:'clinic_login'
        };
        if(this.isA){
          localStorage.setItem('hcpUsername',this.username);
          localStorage.setItem('hcpPassword',this.password);
          localStorage.setItem('hcpRemember',1);
        }else{
          localStorage.setItem('hcpRemember',0);
        }
        if(this.username===""||this.password===""){
          let tip = this.$t('username and password is required');
          this.$message.error(tip);
        }else{
          auth.login(this, info);
        }
      },
      choose(){
        this.isA = !this.isA;
      },
      check2(){
          this.isB = !this.isB;
          if(this.user === ''){
            this.user = this.$t('user');
          }else{
            this.user = '';
          }
      },
      check3(){
        this.isC = !this.isC;
        if(this.pas === ''){
          this.pas = this.$t('password');
        }else{
          this.pas = '';
        }
      },
      up(){
        let obj = document.getElementById('name');
        obj.focus();
      },
      down(){
        let obj = document.getElementById('psd');
        obj.focus();
      },
      sign(){
          this.$router.push('/sign')
      },
      forgot(){
        sessionStorage.removeItem('A');
        sessionStorage.removeItem('B');
        sessionStorage.removeItem('C');
        sessionStorage.removeItem('D');
        this.$router.push('/updatePassword');
        sessionStorage.setItem('udHcp',1);
      },
    },
  }
</script>

<style scoped>
  .container{
    width:400px;
    height:570px;
    margin: 0 auto;
    background: rgba(235,238,241,0.6);
    border-radius:14px;
  }
  .container img{
    width:75px;
    height:64px;
    margin:45px 162px 35px;
  }
  .container p{
    height:40px;
    width:308px;
    margin:0 auto;
    font-family:SFUIText-Medium;
    font-size:30px;
    color:#2aace0;
    letter-spacing:-0.88px;
    line-height:40px;
    text-align:center;
    margin-bottom:50px;
  }
  .icon-bor{
    opacity:0.79;
    background:#ffffff;
    box-shadow:0px 2px 7px 0px rgba(210,210,210,0.50);
    border-radius:100px;
    width:324px;
    height:46px;
    margin:0 auto 30px;
  }
  .icon-bor img{
    display:block;
    width:20px;
    height:23px;
    margin:11px 22px 12px 17px;
    float:left;
  }
  #img1{
    width:19px;
    height: 24px;
  }
  .icon-bor input{
    height:30px;
    width:250px;
    line-height: 30px;
    font-size:22px;
    letter-spacing:-0.69px;
    text-align:left;
    border: none;
    margin-top: 8px;
    font-family:SFUIText-Regular;
    color:#282828;
  }
  .icon-bor input:focus{
    color: #2aace0;
    border: none;
    outline:none;
  }

  .operate{
    width:320px;
    height:19px;
    margin:0 auto;
    font-family: SFUIText-Medium;
  }
  .operate-left{
    float: left;
  }
  .operate-left input{
    cursor: pointer;
  }
  .Select{
    background: url("../assets/Select.png") left center no-repeat;
  }
  .noSelect{
    background: url("../assets/No Select.png") left center no-repeat;
  }
  .operate input{
    width:15px;
    height:19px;
    vertical-align: middle;
    filter:alpha(opacity=0);
    opacity: 0;
  }
  .operate label{
    font-size:16px;
    color:#2aace0;
    letter-spacing:-0.49px;
    text-align:left;
    vertical-align: middle;
    margin-left:6px;
  }
  .operate-right{
    float: right;
  }
  .operate-right label{
    cursor:pointer;
  }
   button{
    height:46px;
    width:324px;
    margin:0 36px;
    border:none;
    font-family: SFUIText-Regular;
    outline: none;
  }
   .po1 .operate-right{
     width: 50%;
     text-align: right;
   }

  .login{
    background:#009fdf;
    border-radius:100px;
    margin-top:38px;
    margin-bottom:8px;
    font-size:20px;
    color:#f6f9fb;
    letter-spacing:-0.69px;
    text-align:center;
    opacity:0.8;
    cursor:pointer;
  }
  .po2{
    margin-top: 34px;
  }
  .login:hover{
    opacity:0.6;
  }
  .sign{
    color:#2aace0;
    letter-spacing:-0.44px;
    text-align:center;
    background-color: transparent;
    margin-bottom: 30px;
    cursor:pointer;
    font-size:18px;
  }
  .sign:hover,.operate-right label:hover{
    opacity: 0.7;
  }
  .in{
     border:1px solid #009fdf;
    *border-radius: 1px;
    *box-shadow: 0 0 0 4px #009fdf;/*模拟圆角，未实现*/
    *outline: 1px solid #009fdf;
    *-moz-outline-radius: 100px;
    height:44px;
    width:322.18px;
  }
  .in1{
    margin-left:-0.5px;
    margin-top:-1px;
  }

  @media screen and (max-width: 1500px){
    .container{
      height:520px;
    }
    .container #user{
      margin:35px 162px 20px;
    }
    .container p{
      margin-bottom:25px;
    }
  }
</style>



// WEBPACK FOOTER //
// LoginHCPClinic.vue?5dd903fa